import React from 'react';
import { Benefits } from '../components/home/Benefits';
import { Coach } from '../components/home/Coach';
import { Community } from '../components/home/Community';
import { Faq } from '../components/home/Faq';
import { FinalCta } from '../components/home/FinalCta';
import { FirstClass } from '../components/home/FirstClass';
import { Hero } from '../components/home/Hero';
import { ParentFeedback } from '../components/home/ParentFeedback';
import { Programs } from '../components/home/Programs';
import { TrustStrip } from '../components/home/TrustStrip';
import { Visit } from '../components/home/Visit';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
export function Home() {
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-323" data-mp="2dfm6dnljq25h">
      <Header data-id="element-324" data-mp="3ku8sxut5cj2q" />
      <main id="main" data-id="element-325" data-mp="3kuqvf96ejtj3">
        <Hero data-id="element-326" data-mp="3kxd5pgkogn50" />
        <TrustStrip data-id="element-327" data-mp="3owvl5wtqc60g" />
        <Programs data-id="element-328" data-mp="3owcdd8xsmy05" />
        <Benefits data-id="element-329" data-mp="3ovu7rlp8r7fk" />
        <Coach data-id="element-330" data-mp="3ov2eihj49lsg" />
        <ParentFeedback data-id="element-331" data-mp="3oyyk56cv19hb" />
        <Community data-id="element-332" data-mp="30wjb2l8dcm2r" />
        <FirstClass data-id="element-333" data-mp="30x1ime0hempz" />
        <Visit data-id="element-334" data-mp="30w9kowjewcwj" />
        <Faq data-id="element-335" data-mp="30w02hv4lza1e" />
        <FinalCta data-id="element-336" data-mp="30uf948u15x54" />
      </main>
      <Footer data-id="element-337" data-mp="2vx6taewcu571" />
    </div>;
}